@if (datatableConfig().columns) {
  <div class="table-container">
    @if (datatableConfig()?.useCustomTooltip || cellTooltipComponent()) {
      <div
        class="custom-cell-tooltip"
        [style.top.px]="cellTooltipTop()"
        [style.left.px]="cellTooltipLeft()"
        [ngClass]="cellTooltipClass()"
        [class.visible]="cellTooltipVisible()"
        [class.tooltip-component]="cellTooltipComponent()"
        [class.above]="cellTooltipAbove()"
      >
        @if (cellTooltipComponent()) {
          <ng-container
            *ngComponentOutlet="cellTooltipComponent(); inputs: { row: cellTooltipRow() }"
          ></ng-container>
        } @else {
          {{ cellTooltipText() }}
        }
      </div>
    }
    @if (isLoading()) {
      <mat-progress-bar
        [mode]="loadingProgress() !== undefined ? 'determinate' : 'indeterminate'"
        [value]="loadingProgress()"
        color="accent"
      ></mat-progress-bar>
    }
    <cdk-virtual-scroll-viewport
      id="innerVirtualScrollViewport"
      [tvsItemSize]="itemHeight()"
      [headerEnabled]="true"
      [headerHeight]="56"
      (scrolledIndexChange)="onScroll($event)"
      class="table-container__virtual-scroll"
      [style.overflow-y]="contextMenuTrigger?.menuOpen ? 'hidden' : 'auto'"
      #virtualScrollViewport
    >
      <table
        mat-table
        matSort
        [trackBy]="trackByFn"
        [matSortActive]="sortConfig()?.initial?.column"
        [matSortDirection]="sortConfig()?.initial?.direction"
        [dataSource]="dataSource"
        multiTemplaterows
        class="mat-elevation-z8"
        cdkDropList
        (cdkDropListDropped)="reorderColumns.emit($event)"
        cdkDropListLockAxis="x"
        cdkDropListOrientation="horizontal"
        [matSortDisabled]="!!datatableConfig()?.disableSort"
        [cdkDropListDisabled]="datatableConfig()?.disableDragColumns || mobileService.isOn()"
        (matSortChange)="emitSortTable($event)"
        [class.compact-table-row-height]="isCompactModeActivated()"
      >
        @if (datatableConfig()?.rowActions?.length) {
          <ng-container matColumnDef="rowActions">
            <th mat-header-cell *matHeaderCellDef [ngClass]="{ 'sticky-end': true }"></th>
            <td
              mat-cell
              *matCellDef="let row"
              [ngClass]="{ 'sticky-end': true }"
              [ngStyle]="datatableConfig()?.rowActionsStyle?.(row)"
            >
              <table-row-actions
                [isCompactMode]="isCompactModeActivated()"
                [actions]="datatableConfig().rowActions"
                [combineActionsThreshold]="datatableConfig().combineActionsThreshold"
                [row]="row"
              ></table-row-actions>
            </td>
          </ng-container>
        }

        @for (column of datatableConfig()?.columns; track column.columnId) {
          <ng-container matColumnDef="{{ column.fieldName }}">
            <!-- Column Header Start -->
            <div>
              @if (column.component?.name === 'DatatableCheckboxComponent') {
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  [matTooltip]="column.headerHoverText"
                  [ngClass]="{
                    stickyHeader: column.sticky === 'start' && !mobileService.isOn(),
                    stickyHeaderAfterCheckbox:
                      column.sticky === 'startAfterCheckbox' && !mobileService.isOn(),
                    'sticky-end': column.sticky === 'end' && !mobileService.isOn(),
                  }"
                  id="{{ getHeaderId(column.fieldName) }}"
                >
                  @if (datatableConfig()?.select?.hideHeaderCheckbox) {
                    {{ `\u00A0\u00A0${column.headerName}\u00A0` }}
                  } @else {
                    <table-datatable-header-checkbox
                      [ids]="getMultiSelectedIds()"
                    ></table-datatable-header-checkbox>
                  }
                </th>
              } @else {
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  [disabled]="column.disableSort"
                  [start]="column.sortStart"
                  cdkDrag
                  [cdkDragDisabled]="datatableConfig()?.disableEditColumns"
                  [matTooltip]="column.headerHoverText"
                  [style.minWidth.px]="column.fixWidthInPx"
                  [class.member-col-width]="column.component?.name === 'MemberChipsCellComponent'"
                  [class.datatable-body__content--pre-line]="!!column.allowBreaks"
                  [class.datatable-body__content--pre]="!!column.allowSpaces"
                  [ngClass]="{
                    stickyHeader: column.sticky === 'start' && !mobileService.isOn(),
                    stickyHeaderAfterCheckbox:
                      column.sticky === 'startAfterCheckbox' && !mobileService.isOn(),
                    'sticky-end': column.sticky === 'end' && !mobileService.isOn(),
                  }"
                  id="{{ getHeaderId(column.fieldName) }}"
                >
                  {{ column.headerName }}
                </th>
              }
            </div>
            <!-- Column Header End -->
            <td
              [style.maxWidth.px]="column.fixWidthInPx"
              mat-cell
              *matCellDef="let row"
              (click)="handleCellClick(column, row, $event)"
              (mouseenter)="showCustomCellTooltip($event, column, row)"
              (mouseleave)="hideCustomCellTooltip()"
              [matTooltip]="row | datatableTooltip: column"
              [matTooltipClass]="column.tooltipClass"
              [matTooltipDisabled]="
                datatableConfig()?.useCustomTooltip ||
                !!column.cellHoverComponent ||
                mobileService.isOn()
              "
              [ngStyle]="column.cellStyle?.(row) ?? {}"
              [ngClass]="{
                sticky: column.sticky === 'start' && !mobileService.isOn(),
                stickyAfterCheckbox:
                  column.sticky === 'startAfterCheckbox' && !mobileService.isOn(),
                'sticky-end': column.sticky === 'end' && !mobileService.isOn(),
                'cursor-pointer': !column.component && !!column.onClick,
                'table-row': componentsThatEmitOnClick.includes(column.component?.name),
                'datatable-body__cell--ellipsis': !!column.ellipsis,
              }"
              app-tour-guide="table-cell"
            >
              @if (!column.component || column.component.doNotUseColumnComponent?.(row)) {
                @if (column.toggle) {
                  <table-datatable-toggle
                    [value]="row | datatableValue: column : isCompactModeActivated()"
                    [row]="row"
                    [toggle]="column.toggle"
                  >
                  </table-datatable-toggle>
                } @else if (column.editable?.(row)) {
                  @if (column.editDropdown; as editDropdown) {
                    <mat-form-field
                      appearance="outline"
                      class="edit-dropdown"
                      (click)="$event.stopPropagation()"
                    >
                      <mat-select
                        [value]="row | datatableValue: column : false : true"
                        (selectionChange)="column.onEditDropdown?.(row, $event.value)"
                      >
                        @for (option of editDropdown(row); track option) {
                          <mat-option [value]="option">{{ option }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  } @else {
                    <input
                      type="text"
                      [value]="row | datatableValue: column : isCompactModeActivated()"
                      (blur)="column.onEdit?.(row, $any($event.target).value)"
                      (click)="$event.stopPropagation()"
                    />
                  }
                } @else {
                  <div
                    class="datatable-body__content"
                    [ngClass]="{
                      'datatable-body__content--ellipsis':
                        (!!column.cellHoverText || !!column.trim) && !column.ellipsis,
                      'datatable-body__content--width-ellipsis': !!column.ellipsis,
                      'datatable-body__content--pre-line': !!column.allowBreaks,
                      'datatable-body__content--pre': !!column.allowSpaces,
                    }"
                  >
                    <span class="datatable-body__text">
                      {{ row | datatableValue: column : isCompactModeActivated() }}
                      @if (column.secondaryText?.(row); as secondary) {
                        <span [ngStyle]="secondary.style">{{ secondary.text }}</span>
                      }
                    </span>
                    @if (column.isLoading?.(row)) {
                      @let progress =
                        column.loadingProgress ? column.loadingProgress(row) : undefined;
                      <div class="datatable-body__spinner">
                        <mat-progress-spinner
                          [mode]="progress !== undefined ? 'determinate' : 'indeterminate'"
                          [value]="progress ?? 0"
                          [diameter]="progress !== undefined ? 24 : 20"
                          strokeWidth="2"
                        ></mat-progress-spinner>
                        @if (progress !== undefined) {
                          <span class="datatable-body__spinner-text">{{ progress }}%</span>
                        }
                      </div>
                    }
                    @if (column.icons) {
                      @for (icon of column.icons; track icon.matIcon) {
                        @if (icon && !icon.doHide?.(row)) {
                          <mat-icon
                            [ngClass]="{ 'icon-disabled': icon.doDisable?.(row) }"
                            (click)="handleIconClick(icon, row, $event)"
                            [class.cursor-pointer]="!!icon.onClick"
                            [color]="icon.color"
                            [attr.color]="icon.color"
                            [matTooltip]="icon.hoverText?.(row)"
                            >{{ icon.matIcon }}
                          </mat-icon>
                        }
                      }
                    }
                  </div>
                }
              } @else if (column.component; as component) {
                @if (component.name === 'ColorPickerComponent') {
                  <vectronic-color-picker
                    [initialColor]="component.input?.initialColor?.(row)"
                    (colorChanged)="component.output?.colorChanged?.($event, row)"
                  ></vectronic-color-picker>
                } @else if (component.name === 'DatatableUsersCountComponent') {
                  <table-datatable-users-count
                    [row]="component.input?.row?.(row)"
                  ></table-datatable-users-count>
                } @else if (component.name === 'GroupChipsCellComponent') {
                  <table-group-chips-cell
                    [member]="component.input?.member?.(row)"
                    [groupsWithMember]="component.input?.groupsWithMember?.(row)"
                    [groups]="component.input?.groups?.(row)"
                    [isCompactModeActivated]="isCompactModeActivated()"
                    (addGroup)="component.output?.addGroup?.($event, row)"
                    (updateGroup)="component.output?.updateGroup?.($event, row)"
                    (deleteGroup)="component.output?.deleteGroup?.($event, row)"
                  ></table-group-chips-cell>
                } @else if (component.name === 'MultiRoleSelectorComponent') {
                  <table-multi-role-selector
                    [allowOwner]="component.input?.allowOwner?.(row)"
                    [hideDeviceManager]="component.input?.hideDeviceManager?.(row)"
                    [row]="component.input?.row?.(row)"
                    [item]="component.input?.item?.(row)"
                    [currentUserEmail]="component.input?.currentUserEmail?.(row)"
                    [ownRole]="component.input?.ownRole?.(row) ?? 'READER'"
                    [canEditPermissions]="component.input?.canEditPermissions?.(row) ?? true"
                    [canModifyOwner]="component.input?.canModifyOwner?.(row) ?? true"
                    [canEditAllRoles]="component.input?.canEditAllRoles?.(row) ?? false"
                    [pendingRequestedShares]="component.input?.pendingRequestedShares?.(row) ?? []"
                    (updateShares)="component.output?.updateShares?.($event, row)"
                    (requestHigherRole)="component.output?.requestHigherRole?.($event, row)"
                    (withdrawRequestedShares)="
                      component.output?.withdrawRequestedShares?.($event, row)
                    "
                  ></table-multi-role-selector>
                } @else if (component.name === 'RoleSelectorComponent') {
                  <table-role-selector
                    [allowOwner]="component.input?.allowOwner?.(row)"
                    [hideDeviceManager]="component.input?.hideDeviceManager?.(row)"
                    [numberOfOwners]="component.input?.numberOfOwners?.(row)"
                    [row]="component.input?.row?.(row)"
                    [ownRole]="component.input?.ownRole?.(row)"
                    [currentUserEmail]="component.input?.currentUserEmail?.(row)"
                    [pendingRequestedShares]="component.input?.pendingRequestedShares?.(row)"
                    (requestHigherRole)="component.output?.requestHigherRole?.($event, row)"
                    (withdrawRequestedShares)="
                      component.output?.withdrawRequestedShares?.($event, row)
                    "
                    (revokeAccess)="component.output?.revokeAccess?.(undefined, row)"
                    (updateShare)="component.output?.updateShare?.($event, row)"
                  ></table-role-selector>
                } @else if (component.name === 'MemberChipsCellComponent') {
                  <table-member-chips-cell
                    [group]="component.input?.group?.(row)"
                    [members]="component.input?.members?.(row)"
                    (updateGroup)="component.output?.updateGroup?.($event, row)"
                  ></table-member-chips-cell>
                } @else if (component.name === 'DatatableIdsTooltipComponent') {
                  <table-datatable-tooltip
                    [row]="component.input?.row?.(row)"
                  ></table-datatable-tooltip>
                } @else if (component.name === 'DatatableListWithActionsComponent') {
                  <table-datatable-list-with-actions
                    [settings]="component.input?.settings?.(row)"
                    [readonly]="component.input?.readonly?.(row)"
                    [compactMode]="isCompactModeActivated()"
                    [showMore]="component.input?.showMore?.()"
                    [horizontalList]="component.input?.horizontalList?.(row)"
                    (buttonClicked)="component.output?.buttonClicked?.($event, row)"
                  >
                  </table-datatable-list-with-actions>
                } @else if (component.name === 'DatatableMovebankSwitchComponent') {
                  <table-datatable-movebank-switch
                    [dataRow]="component.input?.dataRow?.(row)"
                    [movebankAccount]="component.input?.movebankAccount?.(row)"
                    [isCompactMode]="isCompactModeActivated()"
                    (toggleMovebankDevice)="component.output?.toggleMovebankDevice?.($event, row)"
                    (syncCollarWithMovebank)="
                      component.output?.syncCollarWithMovebank?.($event, row)
                    "
                  >
                  </table-datatable-movebank-switch>
                } @else if (component.name === 'NotificationChipsCellComponent') {
                  <table-notification-chips-cell
                    [device]="component.input?.device?.(row)"
                    [rules]="component.input?.rules?.(row)"
                    [addresses]="component.input?.addresses?.(row)"
                    [readonly]="component.input?.readonly?.(row)"
                    [isCompactModeActivated]="isCompactModeActivated()"
                    (addAddressAndRules)="component.output?.addAddressAndRules?.($event, row)"
                    (addRule)="component.output?.addRule?.($event, row)"
                    (deleteRule)="component.output?.deleteRule?.($event, row)"
                  ></table-notification-chips-cell>
                } @else if (component.name === 'DatatableCheckboxComponent') {
                  <table-datatable-checkbox
                    [isCompactMode]="isCompactModeActivated()"
                    [selectionId]="getMultiSelectedId(row)"
                    (checkboxToggle)="
                      onCheckboxToggle($event, row, component.output?.checkboxToggle)
                    "
                  ></table-datatable-checkbox>
                } @else if (component.name === 'DatatableGroupsCheckboxComponent') {
                  <table-datatable-groups-checkbox
                    [row]="component.input?.row?.(row)"
                    (checkboxToggle)="component.output?.checkboxToggle?.($event, row)"
                  ></table-datatable-groups-checkbox>
                } @else if (component.name === 'DatatableBeltComponent') {
                  <table-datatable-belt
                    [belt]="component.input?.belt?.(row)"
                    [idDevice]="component.input?.idDevice?.(row)"
                    [isCompactModeActivated]="isCompactModeActivated()"
                  ></table-datatable-belt>
                } @else if (component.name === 'DatatableDropOffComponent') {
                  <table-datatable-drop-off
                    [row]="component.input?.row?.(row)"
                    [dropOffIds]="component.input?.dropOffIds?.(row)"
                    (addDropOffId)="component.output?.addDropOffId?.($event, row)"
                  >
                  </table-datatable-drop-off>
                } @else if (component.name === 'DatatableDropOffStringComponent') {
                  <table-datatable-drop-off-string
                    [dropOffId]="component.input?.dropOffId?.(row)"
                    [collarId]="component.input?.collarId?.(row)"
                    [type]="component.input?.type?.(row)"
                    [value]="component.input?.value?.(row)"
                    [isCompactModeActivated]="isCompactModeActivated()"
                    (showDropOff)="component.output?.showDropOff?.($event, row)"
                  ></table-datatable-drop-off-string>
                } @else if (component.name === 'DataForwardingChipsCellComponent') {
                  <table-data-forwarding-chips-cell
                    [collarId]="component.input?.collarId?.(row)"
                    [selectedDataForwarders]="component.input?.selectedDataForwarders?.(row)"
                    [dataForwarders]="component.input?.dataForwarders?.(row)"
                    [readonly]="component.input?.readonly?.(row)"
                    [isCompactModeActivated]="isCompactModeActivated()"
                    (addDataForwarder)="component.output?.addDataForwarder?.($event, row)"
                    (deleteDataForwarder)="component.output?.deleteDataForwarder?.($event, row)"
                  ></table-data-forwarding-chips-cell>
                } @else if (component.name === 'MovebankForwardingChipsCellComponent') {
                  <table-movebank-forwarding-chips-cell
                    [collarId]="component.input?.collarId?.(row)"
                    [selectedMovebankForwarders]="
                      component.input?.selectedMovebankForwarders?.(row)
                    "
                    [movebankForwarders]="component.input?.movebankForwarders?.(row)"
                    [readonly]="component.input?.readonly?.(row)"
                    [isCompactModeActivated]="isCompactModeActivated()"
                    (addMovebankForwarder)="component.output?.addMovebankForwarder?.($event, row)"
                    (deleteMovebankForwarder)="
                      component.output?.deleteMovebankForwarder?.($event, row)
                    "
                  ></table-movebank-forwarding-chips-cell>
                } @else if (component.name === 'DatatableJsonComponent') {
                  <table-datatable-json
                    [json]="component.input?.json?.(row)"
                  ></table-datatable-json>
                } @else if (component.name === 'DatatableParameterComponent') {
                  <table-datatable-parameter
                    [parameterDataList]="component.input?.parameterDataList?.(row)"
                    [idDevice]="component.input?.idDevice?.(row)"
                    [deviceClassId]="component.input?.deviceClassId?.(row)"
                    [deviceClasses]="component.input?.deviceClasses?.(row)"
                    [parameters]="component.input?.parameters?.(row)"
                    [categories]="component.input?.categories?.(row)"
                    [subsystems]="component.input?.subsystems?.(row)"
                    [isCompactMode]="isCompactModeActivated()"
                    [deviceTypeParameterConfig]="component.input?.deviceTypeParameterConfig?.(row)"
                  >
                  </table-datatable-parameter>
                } @else if (component.name === 'DatatableDisabledSubsystemsComponent') {
                  <table-datatable-disabled-subsystems
                    [disabledSubsystems]="component.input?.disabledSubsystems?.(row)"
                    [idDevice]="component.input?.idDevice?.(row)"
                    [deviceClassId]="component.input?.deviceClassId?.(row)"
                    [subsystems]="component.input?.subsystems?.(row)"
                    [deviceClasses]="component.input?.deviceClasses?.(row)"
                    [isCompactModeActivated]="isCompactModeActivated()"
                  >
                  </table-datatable-disabled-subsystems>
                } @else if (component.name === 'DatatableSchedulesComponent') {
                  <table-datatable-schedules
                    [schedules]="component.input?.schedules?.(row)"
                    [idDevice]="component.input?.idDevice?.(row)"
                    [virtualFenceConstructionRules]="
                      component.input?.virtualFenceConstructionRules?.(row)
                    "
                    (openCommandModal)="component.output?.openCommandModal?.($event, row)"
                    [isCompactMode]="isCompactModeActivated()"
                  >
                  </table-datatable-schedules>
                } @else if (component.name === 'DatatableCommandContentComponent') {
                  <table-datatable-command-content
                    [row]="component.input?.row?.(row)"
                    [parameters]="component.input?.parameters?.(row)"
                    [isCompactMode]="isCompactModeActivated()"
                  >
                  </table-datatable-command-content>
                } @else if (component.name === 'DatatableMultiValuesContentComponent') {
                  <table-datatable-multi-values-content
                    [values]="component.input?.values?.(row)"
                    [editable]="component.input?.editable?.(row) ?? false"
                    [emptySymbol]="component.input?.emptySymbol?.(row) ?? '—'"
                    [isCompactMode]="isCompactModeActivated()"
                    (cellClick)="component.output?.cellClick?.($event, row)"
                  >
                  </table-datatable-multi-values-content>
                } @else if (component.name === 'DatatableStringWithActionComponent') {
                  <table-datatable-string-with-action
                    [value]="component.input?.value?.(row)"
                    [key]="component.input?.key?.(row)"
                    [row]="component.input?.row?.(row)"
                    (cellActionClick)="component.output?.cellActionClick?.($event, row)"
                  >
                  </table-datatable-string-with-action>
                } @else if (component.name === 'DatatableSvgComponent') {
                  <table-datatable-svg [svg]="component.input?.svg?.(row)"></table-datatable-svg>
                } @else if (component.name === 'DatatableFirmwareComponent') {
                  <table-datatable-firmware
                    [value]="component.input?.value?.(row)"
                    [hasWrite]="component.input?.hasWrite?.(row)"
                    [hasNewerFirmware]="component.input?.hasNewerFirmware?.(row)"
                    (firmwareUpgrade)="component.output?.firmwareUpgrade?.($event, row)"
                  ></table-datatable-firmware>
                } @else if (component.name === 'DatatableEditCheckboxComponent') {
                  <table-datatable-edit-checkbox
                    [value]="component.input?.value?.(row)"
                    [disabled]="component.input?.disabled?.(row)"
                    (checkBoxChange)="component.output?.checkBoxChange?.($event, row)"
                  ></table-datatable-edit-checkbox>
                } @else if (component.name === 'DatatableDateWithRelativeWeeksComponent') {
                  <table-datatable-date-with-relative-weeks
                    [date]="component.input?.date?.(row)"
                    [baseDate]="component.input?.baseDate?.(row)"
                    [label]="component.input?.label?.(row)"
                    [hideRelativeWeeksAndDays]="component.input?.hideRelativeWeeksAndDays?.(row)"
                    [hideRelativeDays]="component.input?.hideRelativeDays?.(row)"
                    [disabled]="component.input?.disabled?.(row)"
                    (dateOutput)="component.output?.dateOutput?.($event, row)"
                  ></table-datatable-date-with-relative-weeks>
                } @else if (component.name === 'ParameterValueComponent') {
                  <vectronic-parameter-value
                    [parameterWithData]="component.input?.parameterWithData?.(row)"
                    [subsystems]="component.input?.subsystems?.(row)"
                  ></vectronic-parameter-value>
                } @else if (component.name === 'DatatableRmaDeviceSelectorComponent') {
                  <table-datatable-rma-device-selector
                    [identification]="component.input?.identification?.(row)"
                    [connectedDevices]="component.input?.connectedDevices?.(row)"
                    [identifiedConnection]="component.input?.identifiedConnection?.(row)"
                    [disabledDeviceIds]="component.input?.disabledDeviceIds?.(row)"
                    [isComplete]="component.input?.isComplete?.(row)"
                    [disabled]="component.input?.disabled?.(row)"
                    (selectDevice)="component.output?.selectDevice?.($event, row)"
                  ></table-datatable-rma-device-selector>
                } @else if (component.name === 'DatatableRmaDescriptionComponent') {
                  <table-datatable-rma-description
                    [description]="component.input?.description?.(row)"
                    [performanceDescription]="component.input?.performanceDescription?.(row)"
                    [parsedDeviceId]="component.input?.parsedDeviceId?.(row)"
                    [identifiedDeviceId]="component.input?.identifiedDeviceId?.(row)"
                    [isInvalid]="component.input?.isInvalid?.(row)"
                  ></table-datatable-rma-description>
                } @else if (component.name === 'DatatableStatusSelectComponent') {
                  <table-datatable-status-select
                    [value]="component.input?.value?.(row)"
                    [options]="component.input?.options?.(row)"
                    [editable]="component.input?.editable?.(row)"
                    [placeholder]="component.input?.placeholder?.(row)"
                    [emptySymbol]="component.input?.emptySymbol?.(row)"
                    [searchable]="component.input?.searchable?.(row)"
                    (valueChange)="component.output?.valueChange?.($event, row)"
                  ></table-datatable-status-select>
                } @else if (component.name === 'DatatableAutocompleteInputComponent') {
                  <table-datatable-autocomplete-input
                    [value]="component.input?.value?.(row)"
                    [options]="component.input?.options?.(row)"
                    [editable]="component.input?.editable?.(row)"
                    [placeholder]="component.input?.placeholder?.(row)"
                    [emptySymbol]="component.input?.emptySymbol?.(row)"
                    [trim]="component.input?.trim?.(row)"
                    (valueChange)="component.output?.valueChange?.($event, row)"
                  ></table-datatable-autocomplete-input>
                } @else if (component.name === 'DatatableInputComponent') {
                  <table-datatable-input
                    [value]="component.input?.value?.(row)"
                    [editable]="component.input?.editable?.(row)"
                    [multiline]="component.input?.multiline?.(row)"
                    [placeholder]="component.input?.placeholder?.(row)"
                    [emptySymbol]="component.input?.emptySymbol?.(row)"
                    [trim]="component.input?.trim?.(row)"
                    (valueChange)="component.output?.valueChange?.($event, row)"
                  ></table-datatable-input>
                }
              }
            </td>
          </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="displayColumnsWithActions(); sticky: true"></tr>
        <tr
          mat-row
          [ngClass]="{
            'row-selected': isInMultiSelect(row),
            'row-click':
              (datatableConfig()?.select?.doMultiHighlight
                ? isRowMultiHighlighted(row)
                : datatableConfig()?.select?.doHighlight
                  ? isRowHighlighted(row)
                  : isSingleSelected(row, true)) || selectedRowForContextMenu() === row,
          }"
          *matRowDef="let row; let i = index; columns: displayColumnsWithActions()"
          [ngStyle]="getRowStyle(row, i)"
          (contextmenu)="onRightClick($event, row)"
          (mousedown)="onRowMouseDown($event)"
        ></tr>
      </table>
    </cdk-virtual-scroll-viewport>
    @if (!data()?.length && !isLoading()) {
      <div class="no-data-overlay">
        <div class="no-data-message">
          {{ datatableConfig()?.noDataText ?? 'No data to display.' }}
        </div>
      </div>
    }
  </div>

  <div
    style="opacity: 0; position: fixed; pointer-events: none"
    [style.left]="contextMenuPosition().x"
    [style.top]="contextMenuPosition().y"
    [matMenuTriggerFor]="contextMenu"
    (contextmenu)="$event.preventDefault()"
  ></div>

  <mat-menu
    #contextMenu="matMenu"
    (closed)="selectedRowForContextMenu.set(undefined)"
    [hasBackdrop]="false"
    (contextmenu)="$event.preventDefault()"
  >
    @if (selectedRowForContextMenu(); as row) {
      @for (action of datatableConfig().rowActions; track $index) {
        @if (!action.doHide?.(row)) {
          <button
            mat-menu-item
            (click)="action.onClick(row)"
            [disabled]="action.doDisable?.(row)"
            [attr.data-testid]="action.testId"
          >
            @if (action.svgIcon) {
              <mat-icon [color]="action.color ?? 'primary'" [svgIcon]="action.svgIcon"></mat-icon>
            } @else {
              <mat-icon [color]="action.color ?? 'primary'">{{ action.matIcon }}</mat-icon>
            }
            {{ action.label }}
          </button>
        }
      }
    }
  </mat-menu>
}
